module.exports = __webpack_public_path__ + "img/data_overview_bac.a7a29941.png";